import { render, staticRenderFns } from "./ChartPetugas.vue?vue&type=template&id=6de3560c&scoped=true"
import script from "./ChartPetugas.vue?vue&type=script&lang=js"
export * from "./ChartPetugas.vue?vue&type=script&lang=js"
import style0 from "./ChartPetugas.vue?vue&type=style&index=0&id=6de3560c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3560c",
  null
  
)

export default component.exports